import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2e0dd395"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "components__rec-quantity-history" }
const _hoisted_2 = {
  key: 0,
  class: "history-label"
}
const _hoisted_3 = {
  key: 1,
  class: "history-scroll"
}
const _hoisted_4 = { class: "history-table" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Zeitraum"),
    /*#__PURE__*/_createElementVNode("th", { class: "history-table__count" }, "Anzahl"),
    /*#__PURE__*/_createElementVNode("th", null, "Status")
  ])
], -1))
const _hoisted_6 = { class: "history-table__period" }
const _hoisted_7 = { class: "history-table__count" }
const _hoisted_8 = {
  key: 2,
  class: "history-empty"
}

import { recProps } from '../../mixins/rec-component';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'rec-quantity-history',
  props: {...recProps()},
  setup(__props) {

  

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.description.label)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.description.label), 1))
      : _createCommentVNode("", true),
    ((_ctx.description.entries || []).length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("table", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.description.entries, (entry) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: entry.id
                }, [
                  _createElementVNode("td", _hoisted_6, _toDisplayString(entry.period), 1),
                  _createElementVNode("td", _hoisted_7, _toDisplayString(entry.count), 1),
                  _createElementVNode("td", null, [
                    _createElementVNode("span", {
                      class: _normalizeClass(["history-status", [entry.status === 'dokumentiert' ? 'history-status--pending' : 'history-status--entrusted']])
                    }, _toDisplayString(entry.status_label), 3)
                  ])
                ]))
              }), 128))
            ])
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_ctx.description.empty_label), 1))
  ]))
}
}

})